import React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";

import "../css/customDatePickerStyles.css";

export default function DatePickerComponentForBio(props) {
  // DatePickerComponent.jsx
  const handleChange = (date) => {
    props.onChange(date);
  };

  const dateObject = props.value;

  return (
    <div className="input-label-container">
      <div className="input-label">
        {props.title}{" "}
        {props.isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          value={dateObject}
          onChange={handleChange}
          format="DD/MM/YYYY"
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              InputProps={{
                style: { padding: "10px", fontSize: "18px", height: 30 },
              }}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "grey",
                },
              }}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
}
